(($) => {
	$(() => {
		$('.bs-media-element--add-background-shape').each((index, element) => {
			const svgPath = `<svg aria-hidden="true" > <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#image-content-bg"></use> </svg>`;
			$(element).find('picture').after(svgPath);
		});
	});
})(jQuery);
